import '../styles/Quotes.css'
import { columnsQuotes, columnsSuppliersAdmin } from '../Component/Hooks/ColumTables'
import Table from '../Component/Tabla/Tabla'
import { useContext, useEffect, useState } from 'react'
import LoginContext from '../Context/Logincontext';
import { urlApiServer } from '../Config/Config'
import Loader from '../Component/Loader';
import EditSuppliers from '../Component/Hooks/EditSuppliers';

const Suppliers = () => {

    const urlGetClient = urlApiServer + "historyproduct"
    const urlgetSuppliers = urlApiServer + "getsuppliers"
    const urlgetConfig = urlApiServer + "getConfig";
    const urlGetRemission = urlApiServer + "getRemission"
    const urlGetCompany = urlApiServer + "company"

    const { infoUser, setInfoUser } = useContext(LoginContext)
    const [suppliersGetTable, setSuppliersGetTable] = useState([])
    const [filterTable, setFilterTable] = useState([])
    const [state, setState] = useState("0")
    const [modify, setModify] = useState({})

    const [powerEdit, setPowerEdit] = useState(true)
    const [powerandoff, setPowerandoff] = useState(true)
    const [id, setId] = useState()
    const [oldConfig, setOldConfig] = useState("")
    const [disabledBottom, setDisabledBottom] = useState(false);


    useEffect(() => {
        (async function () {

            if (infoUser.login !== true) {
                window.location.href = './Login'
            }

            const InicioHeaders = new Headers();
            InicioHeaders.append("Content-Type", "application/json")

            const requesoption = {
                method: 'GET',
                headers: InicioHeaders,
                redirect: 'follow'
            }
            await fetch(urlgetConfig, requesoption).then(response => response.json()).then(quotesResponse => {
                setOldConfig(quotesResponse)
            })
        }())
    }, [])



    useEffect(() => {
        (async function () {
            const InicioHeaders = new Headers();
            InicioHeaders.append("Content-Type", "application/json");
            InicioHeaders.append("company", infoUser.company); // Enviar el nombre de la empresa como encabezado

            const requesoption = {
                method: 'GET',
                headers: InicioHeaders,
                redirect: 'follow'
            };

            await fetch(urlgetSuppliers, requesoption)
                .then(response => response.json())
                .then(quotesResponse => {
                    console.log("quotesResponse: ", quotesResponse)
                    setSuppliersGetTable(quotesResponse.reverse());
                })
                .catch(error => {
                });
        }())

    }, [state, urlGetClient, powerEdit])

    useEffect(() => {
    }, [filterTable])

    useEffect(() => {
        if (disabledBottom) {
            if (powerandoff === true) {
                setPowerandoff(false)
            } else {
                setPowerandoff(true)
            }
        }
    }, [disabledBottom])

    async function edit() {
        if (powerEdit === true) {
            setPowerEdit(false)
        } else {
            setPowerEdit(true)
        }
    }

    async function handleId(e) {
        setId(e)
    }

    async function handleModify(e) {
        setModify(e)
    }

    return (
        <>
            {
                (infoUser.companyType === "Marmol") && (
                    (disabledBottom) && (
                        <div className="backgroundLoader">
                            <Loader />
                        </div>
                    )
                )
            }
            {(infoUser.login === true) ? (
                (infoUser.role === 'SuperUsuario') ? (window.location.href = './Crear_Empresa') : (
                    (powerEdit === true) ? (

                        <>
                            {(infoUser.role === 'Administrador') ? (
                                <>
                                    <Table columns={columnsSuppliersAdmin} data={suppliersGetTable} edit={edit} id={handleId} handleModify={handleModify} />
                                </>
                            ) : (
                                <>
                                    <Table columns={columnsQuotes} data={suppliersGetTable} />
                                </>
                            )}
                        </>
                    ) : (
                        (<EditSuppliers id={id} data={modify} edit={edit}/>)
                    )
                )
            ) : (<></>)}
        </>
    )
}

export default Suppliers